import { render, staticRenderFns } from "./ReturnCodeWidget.vue?vue&type=template&id=db803ef4&scoped=true&"
import script from "./ReturnCodeWidget.vue?vue&type=script&lang=js&"
export * from "./ReturnCodeWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReturnCodeWidget.vue?vue&type=style&index=0&id=db803ef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db803ef4",
  null
  
)

export default component.exports